/* apps/IDSImpactApp/src/app/component/authaftergoogle/authaftergoogle.component.css */
/*# sourceMappingURL=authaftergoogle.component.css.map */
